import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

import Modal from './DemoModal.styled';

const DemoModal = ({ show, closeDemoModal }) => {
  const clickHandler = useCallback(
    /**
     * @param {MouseEvent} e
     */
    (e) => {
      if (e.target.id === 'demo-video-modal') closeDemoModal();
    },
    [closeDemoModal],
  );

  const keyDownHandler = useCallback(
    /**
     * @param {KeyboardEvent} e
     */
    (e) => {
      if (show && (e.key === 'Escape' || e.key === 'Esc')) closeDemoModal();
    },
    [closeDemoModal, show],
  );

  useEffect(() => {
    if (show) window.addEventListener('click', clickHandler);

    return () => window.removeEventListener('click', clickHandler);
  }, [clickHandler, show]);

  useEffect(() => {
    if (show) window.addEventListener('keydown', keyDownHandler);

    return () => window.removeEventListener('keydown', keyDownHandler);
  }, [keyDownHandler, show]);

  return (
    <Modal show={show} className="absolute-inset" id="demo-video-modal">
      <Button type="button" onClick={closeDemoModal} className="close-button">
        <Icon name="close" fill="#ffffff" />
      </Button>
      <div className="content">
        {show && (
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/vkx366sknD4"
            frameBorder="0"
            title="ruttl demo"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    </Modal>
  );
};

DemoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeDemoModal: PropTypes.func.isRequired,
};

export default DemoModal;
